/* Aproflex theme — interactions, timers, quick view and AJAX cart */
(() => {
  const A = window.APX || {};
  const R = A.routes || {};
  const root = (R.root || '/').replace(/\/?$/, '/');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = cents => {
    try { return new Intl.NumberFormat('fr-BE', { style: 'currency', currency: A.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- countdown ---------- */
  const end = A.offerEnd ? new Date(A.offerEnd) : null;
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    if (!end || isNaN(end)) return;
    let t = end - Date.now();
    if (t <= 0) {
      $$('[data-timer]').forEach(el => { el.hidden = true; });
      $$('[data-timer-wrap]').forEach(el => { el.hidden = true; });
      return;
    }
    const d = Math.floor(t / 864e5); t %= 864e5;
    const h = Math.floor(t / 36e5); t %= 36e5;
    const m = Math.floor(t / 6e4);
    const s = Math.floor((t % 6e4) / 1e3);
    $$('[data-timer]').forEach(el => {
      const set = (k, v, u) => {
        const n = el.querySelector('[data-' + k + ']'); if (!n) return;
        const b = n.querySelector('b');
        if (b) b.textContent = pad(v); else n.innerHTML = pad(v) + '<i>' + u + '</i>';
      };
      set('d', d, 'j'); set('h', h, 'h'); set('m', m, 'm'); set('s', s, 's');
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- nav + parallax + reveal ---------- */
  const nav = $('#nav');
  if (nav) addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 30), { passive: true });

  const stage = $('#stage');
  if (stage && !reduced) {
    addEventListener('pointermove', e => {
      const cx = e.clientX / innerWidth - .5, cy = e.clientY / innerHeight - .5;
      $$('[data-depth]', stage).forEach(el => { const d = +el.dataset.depth; el.style.transform = `translate(${cx * d}px, ${cy * d}px)`; });
    }, { passive: true });
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    }), { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    $$('.rv').forEach(el => io.observe(el));
  } else {
    $$('.rv').forEach(el => el.classList.add('in'));
  }

  /* ---------- FAQ ---------- */
  $$('.q button').forEach(b => b.addEventListener('click', () => {
    const o = b.parentElement.classList.toggle('open');
    b.setAttribute('aria-expanded', o);
  }));

  /* ---------- card tilt ---------- */
  $$('.card').forEach(c => {
    c.addEventListener('pointermove', e => {
      if (matchMedia('(hover:none)').matches || reduced) return;
      const r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      c.style.setProperty('--mx', x * 100 + '%'); c.style.setProperty('--my', y * 100 + '%');
      c.style.transform = `perspective(900px) rotateY(${(x - .5) * 6}deg) rotateX(${(.5 - y) * 6}deg) translateY(-4px)`;
    });
    c.addEventListener('pointerleave', () => { c.style.transform = ''; });
    c.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target === c) openQV(c.dataset.card); });
  });

  /* ---------- overlays ---------- */
  const scrim = $('#scrim'), drawer = $('#drawer'), modal = $('#modal');
  function show(el) {
    if (!el) return;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function hideAll() {
    [drawer, modal].forEach(el => { if (el) { el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); } });
    scrim && scrim.classList.remove('on');
    document.body.style.overflow = '';
  }
  scrim && scrim.addEventListener('click', hideAll);
  addEventListener('keydown', e => { if (e.key === 'Escape') hideAll(); });

  /* ---------- quick view ---------- */
  function openQV(handle) {
    const tpl = document.getElementById('qv-' + handle);
    if (!tpl || !modal) return false;
    const body = $('#qvBody');
    body.innerHTML = '';
    body.appendChild(tpl.content.cloneNode(true));
    hideAll(); show(modal);
    return true;
  }

  /* ---------- toast + fly ---------- */
  let tt;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2400);
  }
  function fly(fromEl) {
    const cartBtn = $('#cartBtn');
    if (!fromEl || !cartBtn || reduced) return;
    const scope = fromEl.closest('.card, .qv, .pdp, .duo, .final') || fromEl;
    const srcImg = $('img', scope);
    if (!srcImg) return;
    const a = fromEl.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
    const img = document.createElement('img');
    img.src = srcImg.currentSrc || srcImg.src; img.className = 'flyer'; img.alt = '';
    img.style.cssText = 'left:0;top:0;border-radius:14px';
    document.body.appendChild(img);
    const sx = a.left + a.width / 2 - 45, sy = a.top + a.height / 2 - 45, ex = b.left + b.width / 2 - 45, ey = b.top + b.height / 2 - 45;
    const anim = img.animate([
      { transform: `translate(${sx}px,${sy}px) scale(1)`, opacity: 1 },
      { transform: `translate(${(sx + ex) / 2}px,${Math.min(sy, ey) - 120}px) scale(.7)`, opacity: 1, offset: .5 },
      { transform: `translate(${ex}px,${ey}px) scale(.15)`, opacity: .2 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = () => img.remove();
  }

  /* ---------- cart ---------- */
  let promo = '';
  try { promo = sessionStorage.getItem('apx_code') || ''; } catch (e) {}
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  async function getCart() {
    const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function checkoutUrl() {
    return promo ? `${root}discount/${encodeURIComponent(promo)}?redirect=${encodeURIComponent(root + 'checkout')}` : `${root}checkout`;
  }
  function renderCart(cart) {
    const n = cart.item_count;
    const cc = $('#cartCount'); if (cc) { cc.textContent = n; cc.dataset.n = n; }
    const items = $('#items'); if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = `<div class="empty"><p style="margin-bottom:18px">Ton panier est vide.</p><a class="btn btn-ghost" href="${root}#produits" data-close>Voir les produits</a></div>`;
    } else {
      items.innerHTML = cart.items.map(it => {
        const img = it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=200" alt="" width="76" height="76" loading="lazy">` : '';
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<small>${esc(it.variant_title)}</small>` : '';
        return `<div class="item">
          <a class="th" href="${esc(it.url)}">${img}</a>
          <div><h4>${esc(it.product_title)}</h4>${variant}
            <div class="qty"><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Moins">−</button><span>${it.quantity}</span><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Plus">+</button></div>
          </div>
          <div class="p">${money(it.final_line_price)}<button type="button" class="rm" data-line="${esc(it.key)}" data-q="0">Retirer</button></div>
        </div>`;
      }).join('');
    }
    const dfoot = $('#dfoot'); if (dfoot) dfoot.style.display = cart.items.length ? '' : 'none';
    const total = cart.total_price;
    const threshold = (+A.freeShipFrom || 50) * 100;
    const ship = $('#ship');
    if (ship) {
      const fr = total >= threshold
        ? '<b style="color:var(--fg)">offerte ✓</b>'
        : `3 € — plus que <b style="color:var(--fg)">${money(threshold - total)}</b> pour l'avoir offerte`;
      ship.innerHTML = !cart.items.length
        ? `Livraison gratuite en Belgique · France : offerte dès ${money(threshold)}.`
        : `<b style="color:var(--fg)">Belgique : livraison gratuite ✓</b><br>France : ${fr}<div class="bar"><i style="width:${Math.min(100, total / threshold * 100)}%"></i></div>`;
    }
    const sub = $('#sub'); if (sub) sub.textContent = money(cart.items_subtotal_price);
    const tot = $('#tot'); if (tot) tot.textContent = money(total);
    const co = $('#checkout'); if (co) co.href = checkoutUrl();
  }
  async function refresh() { try { renderCart(await getCart()); } catch (e) {} }

  async function addToCart(id, qty, fromEl) {
    const btn = fromEl && fromEl.closest('button');
    btn && btn.classList.add('loading');
    try {
      const r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] }) });
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        toast(e.description || 'Ce produit n\'est pas disponible pour le moment.');
        return false;
      }
      fly(fromEl);
      const cb = $('#cartBtn'); if (cb) { cb.classList.remove('bump'); void cb.offsetWidth; cb.classList.add('bump'); }
      await refresh();
      toast('✓ Ajouté au panier');
      return true;
    } catch (e) {
      toast('Oups, réessaie dans un instant.');
      return false;
    } finally {
      btn && btn.classList.remove('loading');
    }
  }
  async function changeLine(key, q) {
    await fetch(R.cartChange + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: key, quantity: q }) });
    refresh();
  }
  const qtyOf = el => {
    const scope = el.closest('[data-qty-scope]');
    const q = scope && $('[data-qty]', scope);
    return q ? Math.max(1, parseInt(q.textContent, 10) || 1) : 1;
  };

  /* ---------- promo code ---------- */
  const promoBtn = $('#promoBtn'), promoIn = $('#promoIn'), promoMsg = $('#promoMsg');
  if (promoIn && promo) {
    promoIn.value = promo;
    if (promoMsg) { promoMsg.className = 'promo-msg ok'; promoMsg.textContent = `Code ${promo} : appliqué au moment du paiement.`; }
  }
  promoBtn && promoBtn.addEventListener('click', () => {
    const v = (promoIn.value || '').trim().toUpperCase();
    promo = v;
    try { v ? sessionStorage.setItem('apx_code', v) : sessionStorage.removeItem('apx_code'); } catch (e) {}
    if (promoMsg) {
      promoMsg.className = 'promo-msg' + (v ? ' ok' : '');
      promoMsg.textContent = v ? `Code ${v} : appliqué au moment du paiement.` : 'Entre un code promo.';
    }
    const co = $('#checkout'); if (co) co.href = checkoutUrl();
  });

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', async e => {
    const t = e.target;

    if (t.closest('[data-close]')) { hideAll(); return; }

    const opener = t.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); hideAll(); show(drawer); refresh(); return; }

    const step = t.closest('[data-step]');
    if (step) {
      const scope = step.closest('[data-qty-scope]'); const out = scope && $('[data-qty]', scope);
      if (out) {
        const v = Math.max(1, (parseInt(out.textContent, 10) || 1) + +step.dataset.step);
        out.textContent = v;
        const hidden = scope && $('[data-qty-input]', scope); if (hidden) hidden.value = v;
      }
      return;
    }

    const line = t.closest('[data-line]');
    if (line) { changeLine(line.dataset.line, +line.dataset.q); return; }

    const add = t.closest('[data-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); await addToCart(add.dataset.add, qtyOf(add), add); return; }

    const buy = t.closest('[data-buy]');
    if (buy) { e.preventDefault(); if (await addToCart(buy.dataset.buy, qtyOf(buy), buy)) location.href = checkoutUrl(); return; }

    const thumb = t.closest('.thumbs button[data-src]');
    if (thumb) {
      const main = $('#qvBody img.main');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.src; }
      $$('.thumbs button', thumb.parentElement).forEach(b => b.classList.toggle('on', b === thumb));
      return;
    }

    const pdpThumb = t.closest('[data-pdp-src]');
    if (pdpThumb) {
      const main = $('#pdpMain');
      if (main) { main.removeAttribute('srcset'); main.src = pdpThumb.dataset.pdpSrc; }
      $$('[data-pdp-src]').forEach(b => b.classList.toggle('on', b === pdpThumb));
      return;
    }

    const qv = t.closest('[data-qv-open]');
    if (qv) { if (openQV(qv.dataset.qvOpen)) e.preventDefault(); return; }

    const card = t.closest('.card[data-card]');
    if (card && !t.closest('a, button')) { if (!openQV(card.dataset.card)) location.href = $('a', card).href; }
  });

  /* ---------- product page form ---------- */
  const form = $('#pdpForm');
  if (form) {
    const getId = () => (form.querySelector('[name="id"]') || {}).value;
    const getQty = () => +(form.querySelector('[data-qty-input]') || { value: 1 }).value || 1;
    form.addEventListener('submit', e => {
      e.preventDefault();
      addToCart(getId(), getQty(), form.querySelector('[name="add"]')).then(ok => { if (ok) { hideAll(); show(drawer); } });
    });
    const buyBtn = form.querySelector('[data-buy-form]');
    buyBtn && buyBtn.addEventListener('click', async () => {
      if (await addToCart(getId(), getQty(), buyBtn)) location.href = checkoutUrl();
    });
  }

  refresh();
})();
